import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [openMobileDropdown, setOpenMobileDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (openMobileDropdown) {
      setOpenMobileDropdown(null);
    }
  };

  const toggleMobileDropdown = (dropdownName) => {
    setOpenMobileDropdown(openMobileDropdown === dropdownName ? null : dropdownName);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setOpenMobileDropdown(null);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            <img src="/src/images/Ororo-logo.png" alt="Ororo Software Solutions" className="logo-img" />
          </div>

          <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <li className="nav-item">
              <div className="nav-link" onClick={() => toggleMobileDropdown('services')}>
                Services
                <ChevronDown className="dropdown-arrow" size={16} />
              </div>
              <div className={`dropdown-menu ${openMobileDropdown === 'services' ? 'active' : ''}`}>
                <div className="dropdown-content">
                 
                  
                  <div className="dropdown-section">
                    <h3>Technology Solutions</h3>
                    <p>Transforming businesses with cutting-edge tech solutions.</p>
                    <div className="dropdown-grid">
                      <div className="dropdown-column">
                        <h4><a href="#web">Web Development</a></h4>
                        <p>Modern web applications and platforms</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#mobile">Mobile Development</a></h4>
                        <p>iOS and Android mobile applications</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#data">Data Analytics & BI</a></h4>
                        <p>Data-driven insights and business intelligence</p>
                      </div>
                    </div>
                  </div>
                  <div className="dropdown-section">
                    <h3>Artificial Intelligence</h3>
                    <p>Harnessing AI for smarter decisions and endless possibilities.</p>
                    <div className="dropdown-grid">
                      <div className="dropdown-column">
                        <h4><a href="#generative">Generative AI</a></h4>
                        <p>Creative AI solutions for content generation</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#analytics">Data Analytics and AI/ML Solutions</a></h4>
                        <p>Machine learning and predictive analytics</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li className="nav-item">
              <div className="nav-link" onClick={() => toggleMobileDropdown('industries')}>
                Industries
                <ChevronDown className="dropdown-arrow" size={16} />
              </div>
              <div className={`dropdown-menu ${openMobileDropdown === 'industries' ? 'active' : ''}`}>
                <div className="dropdown-content">
                  <div className="dropdown-section">
                    <h3>Where Tradition Meets Tomorrow</h3>
                    <p>Steer through the ever-changing landscape with our industry expertise.</p>
                    <div className="dropdown-grid">
                      <div className="dropdown-column">
                        <h4><a href="#media">Media & Advertising</a></h4>
                        <p>Transforming storytelling in the digital age.</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#education">Education & EdTech</a></h4>
                        <p>Revolutionizing learning with technology.</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#travel">Travel & Hospitality</a></h4>
                        <p>Crafting memorable experiences with modern solutions.</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#retail">Retail</a></h4>
                        <p>Digital transformation for modern commerce.</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#supply">Supply Chain & Logistics</a></h4>
                        <p>Optimizing operations with smart solutions.</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#healthcare">Healthcare & Life Sciences</a></h4>
                        <p>Advancing healthcare through technology.</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#fintech">FinTech</a></h4>
                        <p>Innovative financial technology solutions.</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#agriculture">Agriculture & Agritech</a></h4>
                        <p>Modernizing agriculture with smart technology.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li className="nav-item">
              <div className="nav-link" onClick={() => toggleMobileDropdown('differentiators')}>
                Differentiators
                <ChevronDown className="dropdown-arrow" size={16} />
              </div>
              <div className={`dropdown-menu ${openMobileDropdown === 'differentiators' ? 'active' : ''}`}>
                <div className="dropdown-content">
                  <div className="dropdown-section">
                    <h3>Why Choose Ororo Software Solutions</h3>
                    <p>What sets us apart in the African tech landscape.</p>
                    <div className="dropdown-grid">
                      <div className="dropdown-column">
                        <h4><a href="#local">Local Expertise</a></h4>
                        <p>Deep understanding of African markets and challenges</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#cost">Cost-Effective Solutions</a></h4>
                        <p>High-quality solutions at competitive prices</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#innovation">Innovation & Technology</a></h4>
                        <p>Cutting-edge technology with local relevance</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li className="nav-item">
              <div className="nav-link" onClick={() => toggleMobileDropdown('about')}>
                About Us
                <ChevronDown className="dropdown-arrow" size={16} />
              </div>
              <div className={`dropdown-menu ${openMobileDropdown === 'about' ? 'active' : ''}`}>
                <div className="dropdown-content">
                  <div className="dropdown-section">
                    <h3>A Legacy of Excellence Since 2015</h3>
                    <p>With decade of experience in delivering excellence, Ororo is consistently moving forward—fusing exceptional talent, efficient processes, and emerging technologies to thrive in the ever-changing business terrain.</p>
                    <div className="dropdown-grid">
                      <div className="dropdown-column">
                        <h4><a href="#story">Our Story</a></h4>
                        <p>From 2015 to today, building Africa's tech future</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#mission">Our Mission</a></h4>
                        <p>Empowering African businesses with innovative software solutions</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#team">Our Team</a></h4>
                        <p>Exceptional talent delivering world-class solutions</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#values">Our Values</a></h4>
                        <p>Excellence, innovation, and African growth</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li className="nav-item">
              <div className="nav-link" onClick={() => toggleMobileDropdown('careers')}>
                Careers
                <ChevronDown className="dropdown-arrow" size={16} />
              </div>
              <div className={`dropdown-menu ${openMobileDropdown === 'careers' ? 'active' : ''}`}>
                <div className="dropdown-content">
                  <div className="dropdown-section">
                    <h3>Join Our Growing Team</h3>
                    <p>Be part of a company that has delivered 200+ products to 50+ valued clients with 95% referral business.</p>
                    <div className="dropdown-grid">
                      <div className="dropdown-column">
                        <h4><a href="#join">Join Our Team</a></h4>
                        <p>Work with exceptional talent and efficient processes</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#positions">Open Positions</a></h4>
                        <p>Current opportunities in African technology</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#why-work">Why Work With Us</a></h4>
                        <p>Thrive in the ever-changing business terrain</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="mailto:careers@ororosolutions.com">Application Process</a></h4>
                        <p>Send your application to careers@ororosolutions.com</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li className="nav-item">
              <div className="nav-link" onClick={() => toggleMobileDropdown('contact')}>
                Contact Us
                <ChevronDown className="dropdown-arrow" size={16} />
              </div>
              <div className={`dropdown-menu ${openMobileDropdown === 'contact' ? 'active' : ''}`}>
                <div className="dropdown-content">
                  <div className="dropdown-section">
                    <h3>Get In Touch</h3>
                    <p>Ready to start your digital transformation journey?</p>
                    <div className="dropdown-grid">
                      <div className="dropdown-column">
                        <h4><a href="mailto:info@ororosolutions.com">Email Us</a></h4>
                        <p>info@ororosolutions.com</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#locations">Office Location</a></h4>
                        <p>1St Antwere Gonno Street - Nungua, Accra, Ghana</p>
                      </div>
                      <div className="dropdown-column">
                        <h4><a href="#quick-contact">Quick Contact</a></h4>
                        <ul>
                          <li><a href="tel:+233536787174">Phone: +233-53-678-7174</a></li>
                          <li><a href="https://wa.me/233536787174">WhatsApp</a></li>
                          <li><a href="#contact-form">Contact Form</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li className="nav-item mobile-only">
              <a href="#contact" className="nav-link" onClick={closeMobileMenu}>Let's Talk</a>
            </li>
          </ul>

          <div className="nav-cta">
            <a href="#contact" className="btn btn-primary">Let's Talk</a>
          </div>

          <button 
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header; 